import axios from "axios";

// const API_BASE = "https://job-auth-y09k.onrender.com/api";
const API_BASE = "https://hourlee.in/api";

const API = axios.create({
  baseURL: API_BASE,
});

export const getCities = () => API.get("/auth/public-cities");
export const getCategories = () => API.get("/auth/public-categories");
export const getIndustries = () => API.get("/auth/public-industries");
export const getActiveCandidate = () => API.get("/auth/top-industryTypes");
export const getExperience = () => API.get("/auth/public-experience-range");
export const getJobTitles = async (letter) => {
  return await API.get(`/auth/list/${letter}`);
};

export const getCandidateList = ({
  page = 1,
  limit = 5,
  city = "",
  jobTitle = "",
  skills = "",
  education = "",
} = {}) => {
  let url = `/auth/public-jobSeekers?page=${page}&limit=${limit}`;

  if (city) url += `&city=${encodeURIComponent(city)}`;
  if (jobTitle) url += `&jobProfile=${encodeURIComponent(jobTitle)}`;
  if (skills) url += `&skills=${encodeURIComponent(skills)}`;
  if (education) url += `&education=${encodeURIComponent(education)}`;

  return API.get(url);
};

export const getIndustryCandidateList = ({
  industryId,
  page = 1,
  limit = 5,
  city = "",
  jobTitle = "",
  skills = "",
  education = "",
} = {}) => {
  let url = `/auth/jobSeekerIndustry/${industryId}?page=${page}&limit=${limit}`;

  if (city) url += `&city=${encodeURIComponent(city)}`;
  if (jobTitle) url += `&jobProfile=${encodeURIComponent(jobTitle)}`;
  if (skills) url += `&skills=${encodeURIComponent(skills)}`;
  if (education) url += `&education=${encodeURIComponent(education)}`;

  return API.get(url);
};

export const getCandidateDetails = async (candidateId) => {
  console.log(candidateId);
  const response = await API.get(`/auth/job-seeker-details/${candidateId}`);
  return response.data;
};

export const getJobTypeData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  // console.log(token);

  const response = await API.get("/auth/job-type", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getExperienceRangeData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/experience-range", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getOtherFieldData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/other-field", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getSalaryTypeData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/salary-type", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getIndustryData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/industries", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getPublicIndustryData = () =>
  API.get("/auth/public-industries?page=1&limit=100");

export const getProfileData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get("/auth/get-company-profile", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Dashboard
export const getProgressData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/company-progress-bar", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getDashboardData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/companyDashboard", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadCompanyProfileImage = (imageFile) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const formData = new FormData();
  formData.append("image", imageFile);

  return API.post("/auth/company-profile-image", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadCompanyProfileData = (profileData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  // console.log("ppooi:", profileData);

  return API.post("/auth/create-company-profile", profileData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const uploadGSTProfile = (data) => {
  const token = localStorage.getItem("token");
      // console.log(data);
  return API.post("/auth/create-company-profile", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getJobPostData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-job-post", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadJobPost = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.post("/auth/create-job-post", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const deleteJobPost = (jobId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.delete("/auth/delete-job-post", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: { id: jobId }, // <-- pass ID here
  });
};

export const getJobPostById = async (jobId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  // console.log("Fetched job post:", token);

  const response = await API.get(`/auth/get-job-post-id/${jobId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // console.log("Fetched job post:", response.data);
  return response.data;
};

export const updateJobPost = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  // console.log("Fetched job post:", token);

  return API.put("/auth/update-job-post", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const changeJobPostStatus = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.put("/auth/jobPostStatus", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getApplicationList = async (jobId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get(`/auth/applicants/${jobId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getConnectedCandidateList = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get(`/auth/approved-applicants`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const applicationStatusChange = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  return API.put(`/auth/employerApproval`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getTaskData = async (applicationId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get(`/auth/my-tasks/${applicationId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadTask = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.put("/auth/update-task", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const candidatePayments = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get(`/auth/approvedCandidatePayment`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const taskPayment = async (applicationId, data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.put(`/auth/task-payment/${applicationId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const paymentHistory = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  // console.log(token);

  const response = await API.get(`/auth/payments`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const notification = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get(`/auth/notifications`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const saveTermsData = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(data);

  return API.post("/auth/termCondition", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
